import FilePickerUploadConfiguration from '../../store/schema/FilePickerUploadConfiguration';
import strings from 'owa-strings/owa-mail-strings';
import { format } from 'owa-strings';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { SelectedFilesSource } from '../../types/FilePickerResult';

// The first string of shareButton array is be the button's text and the second string is its description.
export interface ShareButtonStrings {
    shareText: string;
    shareDescription: string;
}

export default function getShareStringsForActionPanel(
    filesSource: SelectedFilesSource,
    isMultipleSelection: boolean,
    providerDisplayName: string,
    uploadConfiguration: FilePickerUploadConfiguration | null
): ShareButtonStrings {
    let shareButton: ShareButtonStrings;
    if (filesSource === SelectedFilesSource.LocalComputerFiles) {
        let folderName = uploadConfiguration ? uploadConfiguration.folderName : null;
        if (isNullOrWhiteSpace(folderName)) {
            folderName = strings.ActionsPanel_DefaultUploadFolderName;
        }
        let uploadText = uploadConfiguration ? uploadConfiguration.uploadText : null;
        if (isNullOrWhiteSpace(uploadText)) {
            uploadText = format(
                isMultipleSelection
                    ? strings.ActionsPanel_UploadAndShareLink_MultipleFilesText
                    : strings.ActionsPanel_UploadAndShareLink_SingleFileText,
                providerDisplayName
            );
        }

        shareButton = {
            shareText: uploadText,
            shareDescription: format(
                strings.ActionsPanel_UploadAndShareLinkTextDescriptionText,
                folderName
            ),
        };
    } else {
        let shareText: string;
        if (isNullOrWhiteSpace(providerDisplayName)) {
            shareText = isMultipleSelection
                ? strings.ActionsPanel_ShareAsLink_MultipleFilesText
                : strings.ActionsPanel_ShareAsLink_SingleFileText;
        } else {
            shareText = format(
                isMultipleSelection
                    ? strings.ActionsPanel_ShareAsProviderLink_MultipleFilesText
                    : strings.ActionsPanel_ShareAsProviderLink_SingleFileText,
                providerDisplayName
            );
        }
        shareButton = {
            shareText: shareText,
            shareDescription: strings.ActionsPanel_ShareAsProviderLinkTextDescriptionText,
        };
    }

    return shareButton;
}
